module.exports = __webpack_public_path__ + "img/carousel-1.a3261423.jpg";